import api from './client';

export interface RatioItem {
  key: string;
  value: number;
  unit: string | null;
  description: string | null;
  source: string | null;
  is_author_decision: boolean;
  is_custom: boolean;
}

export interface BenchmarkItem {
  key: string;
  value: number;
  unit: string | null;
  description: string | null;
  source: string | null;
  is_custom: boolean;
}

export async function fetchRatios() {
  const res = await api.get<RatioItem[]>('/ratios');
  return res.data;
}

export async function fetchBenchmarks() {
  const res = await api.get<BenchmarkItem[]>('/benchmarks');
  return res.data;
}

export async function updateRatio(key: string, data: { value: number; description?: string; source?: string }) {
  const res = await api.put<RatioItem>(`/ratios/${key}`, data);
  return res.data;
}

export async function updateBenchmark(key: string, data: { value: number; description?: string; source?: string }) {
  const res = await api.put<BenchmarkItem>(`/benchmarks/${key}`, data);
  return res.data;
}

export async function resetRatio(key: string) {
  const res = await api.delete<RatioItem>(`/ratios/${key}/reset`);
  return res.data;
}

export async function resetBenchmark(key: string) {
  const res = await api.delete<BenchmarkItem>(`/benchmarks/${key}/reset`);
  return res.data;
}

/* ── Custom Subsidies CRUD ── */

export interface CustomSubsidyRule {
  id: string;
  category_key: string;
  organe: string;
  label: string;
  base_type: string;
  taux: number | null;
  montant: number | null;
  modalite: string | null;
  timing: string | null;
  duree_ans: number | null;
  sort_order: number;
  is_custom: boolean;
}

export async function fetchCustomSubsidies() {
  const res = await api.get<CustomSubsidyRule[]>('/subsidies/custom');
  return res.data;
}

export async function createCustomSubsidy(data: {
  category_key: string;
  organe?: string;
  label: string;
  base_type: string;
  taux?: number | null;
  montant?: number | null;
  timing?: string | null;
}) {
  const res = await api.post<CustomSubsidyRule>('/subsidies/custom', data);
  return res.data;
}

export async function updateCustomSubsidyApi(id: string, data: Record<string, unknown>) {
  const res = await api.put<CustomSubsidyRule>(`/subsidies/custom/${id}`, data);
  return res.data;
}

export async function deleteCustomSubsidyApi(id: string) {
  await api.delete(`/subsidies/custom/${id}`);
}
